import React from 'react'
import PropTypes from 'prop-types'
import BuildFilter from './BuildFilter'
import styles from './styles.css'
import AllLocationsCheckbox from '../../sitewide/Filter/AllLocationsCheckbox'

const FilterRow = ({
  doctors,
  handleAllLocationsCheck,
  hasDSO,
  locations,
  searchAllLocations,
  selectedDoctor,
  selectedLocationId,
  updateFilterSelection,
}) => (
  <div className={styles.filterRow}>
    {hasDSO && locations && locations.length > 1 && (
      <div className={styles.allLocationCheckbox}>
        <AllLocationsCheckbox
          checked={searchAllLocations}
          handleCheck={handleAllLocationsCheck}
        />
      </div>
    )}
    <p className={styles.filterLabel}>Filter Results:</p>
    <BuildFilter
      defaultOption="All Doctors"
      name="selectedDoctor"
      onChange={updateFilterSelection}
      optionsArr={doctors}
      optionLabel="preferred_name"
      value={selectedDoctor}
    />
    {!hasDSO && locations && locations.length > 1 && (
      <BuildFilter
        defaultOption="All Locations"
        name="selectedLocationId"
        onChange={updateFilterSelection}
        optionsArr={locations}
        optionLabel="name"
        value={selectedLocationId}
      />
    )}
  </div>
)

FilterRow.propTypes = {
  doctors: PropTypes.arrayOf(PropTypes.object),
  handleAllLocationsCheck: PropTypes.func.isRequired,
  hasDSO: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  searchAllLocations: PropTypes.bool.isRequired,
  selectedDoctor: PropTypes.string.isRequired,
  selectedLocationId: PropTypes.string.isRequired,
  updateFilterSelection: PropTypes.func.isRequired,
}

export default FilterRow



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingPatients/FilterRow.js